export const isStringEmpty = value =>
  value === '' || value === undefined || value === null || value === 'undefined';

export const isNumberEmpty = (value) => {
  return isStringEmpty(value) || String(value) === '0' 
}

export const validateCompareInput = (compareFor, comparingValue, inputValue, name, formSubmitErrors, setFormSubmitErrors) => {
    let enteredValue = Number(inputValue);
    if(compareFor === "greater"){
      if(!Number.isNaN(enteredValue) && typeof(comparingValue) === "number" && enteredValue < comparingValue){
        let errorObject = formSubmitErrors;
        if(errorObject[name]){
          errorObject[name] = "smaller field value";
        }else{
          errorObject[name] = {};
          errorObject[name] = "smaller field value";
        }
        setFormSubmitErrors({...errorObject});
      }else if(Number.isNaN(enteredValue) && typeof(comparingValue) == "number"){
        let errorObject = formSubmitErrors;
        if(errorObject[name]){
          errorObject[name] = "invalid field value";
        }else{
          errorObject[name] = {};
          errorObject[name] = "invalid field value";
        }
        setFormSubmitErrors({...errorObject});
      }else{
        let errorObject = formSubmitErrors;
        delete errorObject[name]
        setFormSubmitErrors({...errorObject});
      }
    } else if(compareFor === "smaller"){
      if(!Number.isNaN(enteredValue) && typeof(comparingValue) === "number" && enteredValue > comparingValue){
        let errorObject = formSubmitErrors;
        if(errorObject[name]){
          errorObject[name] = "greater field value";
        }else{
          errorObject[name] = {};
          errorObject[name] = "greater field value";
        }
        setFormSubmitErrors({...errorObject});
      }else if(Number.isNaN(enteredValue) && typeof(comparingValue) == "number"){
        let errorObject = formSubmitErrors;
        if(errorObject[name]){
          errorObject[name] = "invalid field value";
        }else{
          errorObject[name] = {};
          errorObject[name] = "invalid field value";
        }
        setFormSubmitErrors({...errorObject});
      }else{
        let errorObject = formSubmitErrors;
        if(errorObject[name]){
          errorObject[name] = null;
        }else{
          errorObject[name] = {};
          errorObject[name] = null;
        }
        setFormSubmitErrors({...errorObject});
      }
    }
}
